import * as types from "../constants/actionTypes";



export function setTranslationMessagesByLang(l) {
    console.log('setTranslationMessagesByLang', l);
    return {type: types.SET_TRANSLATIONS, l };
}

